import { render, staticRenderFns } from "./LevelRewards.vue?vue&type=template&id=3f20126f"
import script from "./LevelRewards.vue?vue&type=script&lang=ts"
export * from "./LevelRewards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports